<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Thêm mới tài khoản</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="20">
          <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel">
            <el-form-item prop="avatar" label="Ảnh đại diện">
              <el-upload
                class="avatar-uploader"
                :action="upload.url"
                :headers="upload.headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-progress="handleAvatarProcess"
                :before-upload="beforeAvatarUpload">
                <img v-if="modelData.avatar_path" :src="modelData.avatar_path" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">
                  <i class="fas fa-spinner fa-spin" v-if="upload.uploadProcess"></i>
                  Ảnh đại diện tải lên có dung lượng tối đa là 2Mb
                </div>
              </el-upload>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="name" label="Họ và tên" class="form-item">
                  <el-input v-model="modelData.name" class="input-seach" ref="myInput"></el-input>
                </el-form-item>
                <el-form-item prop="email" label="Email đăng nhập" class="form-item">
                  <el-input v-model="modelData.email" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="password" label="Mật khẩu" class="form-item">
                  <el-input type="password" v-model="modelData.password" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="password_confirmation" label="Xác nhận mật khẩu" class="form-item">
                  <el-input type="password" v-model="modelData.password_confirmation" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="user_type" label="Loại tài khoản" class="form-item">
                  <el-select v-model="modelData.user_type" filterable placeholder="Loại tài khoản" class="input-select">
                    <el-option
                      v-for="item in lists.listUserType"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="birthday" label="Ngày sinh" class="form-item input-daterange">
                  <el-date-picker
                    v-model="modelData.birthday"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="Ngày sinh">
                  </el-date-picker>
                </el-form-item>
                <el-form-item prop="phone" label="Số điện thoại" class="form-item">
                  <el-input v-model="modelData.phone" class="input-seach" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item prop="address" label="Địa chỉ" class="form-item">
                  <el-input v-model="modelData.address" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="sex" label="Giới tính" class="form-item">
                  <el-select v-model="modelData.sex" filterable placeholder="Giới tính" class="input-select">
                    <el-option
                      v-for="item in lists.listSex"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Kích hoạt" prop="status">
                  <el-switch
                    active-color="#13ce66"
                    inactive-color="#7f8c8d"
                    v-model="modelData.status">
                  </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item prop="user_content" label="Giới thiệu về tài khoản">
              <tinymce
                id="d1"
                v-model="modelData.user_content"
                :toolbar1="tinymce.toolbar1"
                :other_options="{ height: '500px', language_url: '/static/plugins/tinymce/vi_VN.js' }"></tinymce>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="success"
                  size="small"
                  @click="submitForm('createModel')">Lưu lại</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
import tinymce from 'vue-tinymce-editor'
import ls from 'local-storage'
export default {
  name: 'UserCreate',
  metaInfo () {
    return {
      title: 'Tài khoản | Thêm'
    }
  },
  components: {
    tinymce
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        name: '',
        email: '',
        phone: '',
        avatar: '',
        avatar_path: '',
        password: '',
        password_confirmation: '',
        address: '',
        birthday: '',
        sex: 1,
        user_type: '',
        user_content: '',
        status: true
      },
      lists: {
        listUserType: [
          {key: 2, value: 'Giảng viên'},
          {key: 3, value: 'Học viên'}
          // {key: 4, value: 'Nhà phân phối'}
        ],
        listSex: [
          {key: 1, value: 'Nam'},
          {key: 0, value: 'Nữ'}
        ]
      },
      upload: {
        uploadProcess: false,
        url: process.env.API_URI + 'users/upload',
        headers: {
          Authorization: ''
        }
      },
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      rules: {
        name: [
          { required: true, message: 'Vui lòng nhập họ và tên' },
          { min: 2, max: 50, message: 'Họ và tên có chiều dài từ 2 tới 50 kí tự' }
        ],
        email: [
          { required: true, message: 'Vui lòng nhập email đăng nhập' },
          { type: 'email', message: 'Email không đúng định dạng' }
        ],
        password: [
          { required: true, message: 'Vui lòng nhập mật khẩu' }
        ],
        password_confirmation: [
          { required: true, message: 'Vui lòng nhập mật khẩu xác nhận' }
        ],
        user_type: [
          { required: true, message: 'Vui lòng nhập loại tài khoản' }
        ]
      }
    }
  },
  mounted () {
    this.$refs.myInput.focus()
    this.configBreadcrumb()
    this.configUpload()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'users-index', text: 'Tài khoản' },
        { name: 'users-create', text: 'Thêm mới' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Cấu hình Upload
    configUpload () {
      const token = ls.get('authen', '')
      if (token) {
        this.upload.headers.Authorization = `Bearer ${token.access_token}`
      } else {
        this.upload.headers.Authorization = 'Bearer'
      }
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'users-index'})
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    storeModel () {
      this.canSubmit = false
      axios.post('users', this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Thêm tài khoản thành công',
              type: 'success'
            })
            this.$router.push({name: 'users-index'})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Upload Ảnh
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('Ảnh đại diện có dung lượng ảnh tối đa là 2M')
      }
      return isLt2M
    },
    handleAvatarSuccess (response) {
      this.upload.uploadProcess = false
      if (response.code) {
        this.modelData.avatar = response.data.name
        this.modelData.avatar_path = response.data.path
      }
    },
    handleAvatarProcess (event, file, fileList) {
      this.upload.uploadProcess = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>

<style type="text/css">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/users/Create.vue